import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { FormItem } from "@freightsimple/ui-core/FormLayout/FormItem";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { T } from "@freightsimple/ui-core/Typography/T";
import { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";

interface ShipmentStatesDropdownProps {
  shipmentState: ShipmentState | undefined;
  onShipmentStateChange: (newValue: ShipmentState | undefined) => void;
}

const stateIcons: Record<string, string> = {
  [ShipmentState.BookingConfirmed]: "🟡",
  [ShipmentState.InTransit]: "🔵",
  [ShipmentState.Delivered]: "🟢",
  [ShipmentState.Cancelled]: "⚫️",
  [ShipmentState.Lost]: "⚫️",
};

const stateLabels: Record<string, string> = {
  "any-state": "Any status",
  [ShipmentState.BookingConfirmed]: "Booked",
  [ShipmentState.InTransit]: "In Transit",
  [ShipmentState.Delivered]: "Delivered",
  [ShipmentState.Cancelled]: "Cancelled",
  [ShipmentState.Lost]: "Lost",
};

const options = [
  { value: "any-state", label: "Any status" },
  { value: ShipmentState.BookingConfirmed, label: "Booked" },
  { value: ShipmentState.InTransit, label: "In Transit" },
  { value: ShipmentState.Delivered, label: "Delivered" },
  { value: ShipmentState.Cancelled, label: "Cancelled" },
  { value: ShipmentState.Lost, label: "Lost" },
];

function ShipmentFilterShipmentStatesDropdown(
  props: ShipmentStatesDropdownProps,
) {
  return (
    // Labelled like every other filter: unlabelled, the only clue to what the
    // control did was its "Any status" placeholder, which vanishes the moment
    // a status is picked.
    <FormItem label="Status" fillWidth>
      <Dropdown
        placeholder="Any status"
        width="full"
        value={props.shipmentState}
        onChange={(v) => {
          if (v === "any-state") {
            props.onShipmentStateChange(undefined);
          } else {
            props.onShipmentStateChange(v as ShipmentState);
          }
        }}
        options={options}
        renderOption={(option) => (
          <Row gap={2}>
            <T>{stateIcons[option.value] ?? ""}</T>
            <T>{stateLabels[option.value] ?? option.label}</T>
          </Row>
        )}
      />
    </FormItem>
  );
}
export default ShipmentFilterShipmentStatesDropdown;
